export default "__VITE_ASSET__Ba5AvQN8__"